import { Component, Input, inject } from '@angular/core';
import { CLIPBOARD } from '@shared/dom';

@Component({
  selector: 'app-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss'],
  standalone: false,
})
export class CopyButtonComponent {
  private readonly clipboard = inject<Clipboard>(CLIPBOARD);

  public readonly COPY_MSG_DELAY_MS = 5000;
  public copied = false;
  public canCopy = true;
  public copyError = false;

  @Input() value: string;

  public async copy(): Promise<void> {
    try {
      await this.clipboard.writeText(this.value);

      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, this.COPY_MSG_DELAY_MS);
    } catch {
      this.canCopy = false;
      this.copyError = true;
      setTimeout(() => {
        this.copyError = false;
      }, this.COPY_MSG_DELAY_MS);
    }
  }
}
